import { useModel } from '@umijs/max';
import { theme } from 'antd';
import React from 'react';
import { CustomerServiceHoverQr } from './CustomerServiceHoverQr';

/**
 * side 布局下 ProLayout 不会在右侧内容区渲染顶栏，`avatarProps` / `actionsRender` 只会落在侧栏底部。
 * 在 `childrenRender` 里用本组件作为「内容区顶部工具条」：积分、客服、主题、语言、用户等；并与 layout 里关闭侧栏重复项配合使用。
 *
 * 后续新增工具区内容：在本文件内 `{children}` 前追加同级节点即可（与顶栏 `gap: 8` 一致）。
 */
const ContentToolbar: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { token } = theme.useToken();
  const { initialState } = useModel('@@initialState');
  const raw = initialState?.currentUser?.points;
  const points = raw == null ? 0 : raw;
  const isDark = initialState?.settings?.navTheme === 'realDark';
  const quantityColor = isDark ? '#a3a3a3' : '#737373';

  const pointsBlock = (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 3,
        userSelect: 'none',
        paddingRight: 4,
        paddingLeft: 4,
      }}
    >
      <i
        className="iconfont icon-Sparkle"
        style={{ color: '#f59e0b', fontSize: 18, lineHeight: 1 }}
        aria-hidden
      />
      <span
        style={{
          color: quantityColor,
          fontSize: '0.75rem',
          lineHeight: 1,
        }}
      >
        {points}
      </span>
    </span>
  );

  const customerService = (
    <CustomerServiceHoverQr>
      <span
        role="button"
        tabIndex={0}
        style={{
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          paddingRight: 4,
          paddingLeft: 4,
          lineHeight: 1,
          color: token.colorTextSecondary,
        }}
        aria-label="客服"
      >
        <i
          className="iconfont icon-message_circle"
          style={{
            fontSize: 18,
            lineHeight: 1,
            paddingRight: 4,
            paddingLeft: 4,
          }}
          aria-hidden
        />
      </span>
    </CustomerServiceHoverQr>
  );

  return (
    <div
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: 8,
        flexShrink: 0,
        paddingBlock: 12,
        paddingInline: 16,
        background: token.colorBgLayout,
      }}
    >
      {pointsBlock}
      {customerService}
      {children}
    </div>
  );
};

export default ContentToolbar;

